import request from '@/utils/request'

// 查询确认单模板
export function findConfirmationFormSendRecord(params) {
  return request({
    url: `/confirmation_form_send_records`,
    method: 'get',
    params: params
  })
}

export function sendConfirmationForm(id, data) {
  return request({
    url: `/confirmation_form_send_records/${id}/send`,
    method: 'post',
    data
  })
}

export function findConfirmationFormSendRecordPicture(id, params) {
  return request({
    url: `/confirmation_form_send_records/${id}/picture`,
    method: 'get',
    params: params
  })
}

export function findConfirmationFormSendRecordDetails(id, params) {
  return request({
    url: `/confirmation_form_send_records/${id}/details`,
    method: 'get',
    params: params
  })
}
